import React from 'react';

function App(props) {
  const { innerHeight: height } = window;
  var contents = props.contents;
  if (!contents){
	  contents = "https://www.youtube.com/embed/brLKt1KKrKU";
	}
	contents = contents.replace("/watch?v=", "/embed/").replace("http://", "https://");
  if (contents.indexOf("youtube") >  0){
    return <iframe width="560" title="you" height="315" src={contents} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>              
  }else{
    return <iframe width="90%" title="you" height={height * 0.5} src={contents} frameborder="0" ></iframe>              
  }
}
export default App;
